import { Model } from '@app/models/core/base.model';
import { DriveTypeEnum } from '@app/modules/documents-v2/enums/drive-type.enum';
import { Node } from '@models/documents/directory/node.model';

export class Drive extends Model {
    protected static _resource = 'directories/drives';
    protected static _version = 'v2';

    protected static _type = 'directoryDrive';

    protected static _serializeAttributes = ['type'];

    get companyId(): number {
        return this._attributes['companyId'];
    }

    get type(): string {
        return this._attributes['type'];
    }

    get node(): Node {
        return this.hasOne(Node, 'node');
    }

    isEmployee(): boolean {
        return this._attributes['type'] === DriveTypeEnum.employee;
    }

    isPrivate(): boolean {
        return this._attributes['type'] === DriveTypeEnum.private;
    }

    isPublic(): boolean {
        return this._attributes['type'] === DriveTypeEnum.public;
    }
}
